function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.25 21.4619C17.25 21.0477 17.5858 20.7119 18 20.7119H21C21.4142 20.7119 21.75 21.0477 21.75 21.4619C21.75 21.8761 21.4142 22.2119 21 22.2119H18C17.5858 22.2119 17.25 21.8761 17.25 21.4619Z",
  fill: "#2E3545"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.25 21.4619C2.25 21.0477 2.58579 20.7119 3 20.7119H6C6.41421 20.7119 6.75 21.0477 6.75 21.4619C6.75 21.8761 6.41421 22.2119 6 22.2119H3C2.58579 22.2119 2.25 21.8761 2.25 21.4619Z",
  fill: "#2E3545"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.25 12.4619C5.25 12.0477 5.58579 11.7119 6 11.7119H18C18.4142 11.7119 18.75 12.0477 18.75 12.4619V21.4619C18.75 21.8761 18.4142 22.2119 18 22.2119C17.5858 22.2119 17.25 21.8761 17.25 21.4619V13.2119H6.75V21.4619C6.75 21.8761 6.41421 22.2119 6 22.2119C5.58579 22.2119 5.25 21.8761 5.25 21.4619V12.4619Z",
  fill: "#2E3545"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.25 8.46191C9.25 8.0477 9.58579 7.71191 10 7.71191H14C14.4142 7.71191 14.75 8.0477 14.75 8.46191C14.75 8.87613 14.4142 9.21191 14 9.21191H10C9.58579 9.21191 9.25 8.87613 9.25 8.46191Z",
  fill: "#2E3545"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3356 2.16963C13.3357 2.16968 13.3355 2.16958 13.3356 2.16963L20.3346 6.05808C20.3348 6.05816 20.3345 6.05801 20.3346 6.05808C21.2082 6.54254 21.75 7.46403 21.75 8.46204V21.462C21.75 21.8763 21.4142 22.212 21 22.212C20.5858 22.212 20.25 21.8763 20.25 21.462V8.46204C20.25 8.00821 20.0035 7.5896 19.6074 7.37L12.6068 3.48066C12.2295 3.27077 11.7699 3.27057 11.3926 3.48045L4.39224 7.36966C3.99681 7.5892 3.75 8.00806 3.75 8.46204V21.462C3.75 21.8763 3.41421 22.212 3 22.212C2.58579 22.212 2.25 21.8763 2.25 21.462V8.46204C2.25 7.46409 2.7913 6.54291 3.66376 6.05843M3.66376 6.05843L10.6634 2.16963C11.4939 1.70778 12.5051 1.70778 13.3356 2.16963C13.3357 2.16968 13.3355 2.16958 13.3356 2.16963",
  fill: "#2E3545"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.75 19.2119V20.7119H14.25V19.2119H12.75ZM11.25 19.1279C11.25 18.345 11.8845 17.7119 12.667 17.7119H14.334C15.1169 17.7119 15.75 18.3464 15.75 19.1289V20.7959C15.75 21.5789 15.1155 22.2119 14.333 22.2119H12.666C11.8831 22.2119 11.25 21.5774 11.25 20.7949V19.1279Z",
  fill: "#2E3545"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.75 19.2119V20.7119H11.25V19.2119H9.75ZM8.25 19.1279C8.25 18.345 8.88452 17.7119 9.667 17.7119H11.334C12.1169 17.7119 12.75 18.3464 12.75 19.1289V20.7959C12.75 21.5789 12.1155 22.2119 11.333 22.2119H9.667C8.88379 22.2119 8.25 21.5781 8.25 20.7949V19.1279Z",
  fill: "#2E3545"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.249 16.2109V17.7119H12.75V16.2109H11.249ZM9.74899 16.1279C9.74899 15.3465 10.382 14.7109 11.166 14.7109H12.833C13.6145 14.7109 14.25 15.344 14.25 16.1279V17.7949C14.25 18.5782 13.6162 19.2119 12.833 19.2119H11.166C10.3845 19.2119 9.74899 18.5789 9.74899 17.7949V16.1279Z",
  fill: "#2E3545"
});

function SvgWarehouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.f29b8245.svg";
export { ForwardRef as ReactComponent };